module.exports = __webpack_public_path__ + "media/images/vp/icon.delete.black-ee46ca53f7fd77b32d4294985f1bd1be.svg";